import { useState, useEffect } from 'react'
import { SelectFolder } from '../SelectFolder'
import { SelectEmployee } from '../SelectEmployee'
import DocManagementService from '../../../../../../API/Documents/DocumentManagement'

export const CreateFolderModal = ({ isOpen, onClose, folders = [], employeesList = [], onCreated }) => {
	const companyId = JSON.parse(localStorage.getItem('user')).id
	const [name, setName] = useState('')
	const [selectedFolder, setSelectedFolder] = useState(null)
	const [selectedEmployees, setSelectedEmployees] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		if (isOpen) {
			setSelectedEmployees(employeesList.map(e => e.id))
		} else {
			setName('')
			setSelectedFolder(null)
			setSelectedEmployees([])
			setError('')
		}
	}, [isOpen, employeesList])

	function isCommonOrChildOfCommon(folders, folderId) {
		if (!folderId) return false
		let folder = folders.find(f => f.id === folderId)
		while (folder) {
			if (folder.parentId === null && folder.private === false) return true
			folder = folders.find(f => f.id === folder.parentId)
		}
		return false
	}

	const isSelectedCommonOrChild = isCommonOrChildOfCommon(folders, selectedFolder)

	const handleCreate = async () => {
		if (!name.trim()) {
			setError('Nome obrigatório')
			return
		}
		setLoading(true)
		setError('')
		try {
			const parentFolder = folders.find(f => f.id === selectedFolder)
			const isPrivate = parentFolder ? !!parentFolder.private : false
			const data = {
				name: name,
				companyId: companyId,
				parentId: selectedFolder,
				private: isPrivate,
			}
			if (!isPrivate && selectedEmployees.length > 0 && selectedEmployees.length < employeesList.length) {
				data.employeeIds = selectedEmployees
			}
			if (isPrivate && selectedEmployees.length === 1) {
				data.employeeId = selectedEmployees[0]
			}

			await DocManagementService.createFolder(data)
			onCreated && onCreated()
			onClose()
		} catch (e) {
			setError('Erro ao criar pasta')
		} finally {
			setLoading(false)
		}
	}

	const isValid = name.trim() && selectedFolder && selectedEmployees.length > 0

	if (!isOpen) return null

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-z-50 tw-flex tw-items-center tw-justify-center'>
			<div className='tw-bg-white tw-rounded-xl tw-shadow-lg  tw-p-6 tw-w-[634px] tw-relative'>
				<div className='tw-text-lg tw-font-medium tw-mb-6'>Crear nueva carpeta</div>
				<div className='tw-mb-4'>
					<label className='tw-block tw-font-bold tw-mb-1'>Nombre de la carpeta</label>
					<input
						className='border tw-rounded-lg  tw-px-3 tw-py-2 tw-w-full'
						value={name}
						onChange={e => setName(e.target.value)}
						disabled={loading}
					/>
				</div>
				<div className='tw-mb-4'>
					<label className='tw-block tw-font-bold tw-mb-1'>Ubiación de la nueva carpeta</label>
					<SelectFolder folders={folders} onSelect={setSelectedFolder} selectedFolder={selectedFolder} />
				</div>
				{isSelectedCommonOrChild && (
					<div className='tw-mb-4'>
						<label className='tw-block tw-font-bold tw-mb-1'>Seleccionar Colaboradores</label>
						<div className='tw-text-sm tw-text-gray-500 tw-mb-2'>Selecciona a los colaboradores que tendrán acceso a la nueva carpeta.</div>
						<SelectEmployee employees={employeesList} onSelect={setSelectedEmployees} selectedEmployees={selectedEmployees} multiple={true} />
					</div>
				)}
				{error && <div className='tw-text-red-500 tw-mb-2'>{error}</div>}
				<div className='tw-flex tw-justify-end tw-gap-3'>
					<div
						onClick={onClose}
						className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
						disabled={loading}
					>
						Cancelar
					</div>
					<div
						onClick={handleCreate}
						className={`tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg ${
							!isValid || loading ? 'tw-opacity-50 tw-cursor-not-allowed' : ''
						}`}
						disabled={!isValid || loading}
						style={{ pointerEvents: !isValid || loading ? 'none' : 'auto' }}
					>
						{loading ? 'Creando...' : 'Crear carpeta'}
					</div>
				</div>
			</div>
		</div>
	)
}

export default CreateFolderModal
